export default __webpack_public_path__ + "static/media/ugb.f0bad8e9.png";